export const IS_WHATSAPP_ENABLED =
  process.env.NEXT_PUBLIC_IS_WHATSAPP_ENABLED === 'true'

export const IS_CELEBRATORY_WALLETS_ENABLED =
  process.env.NEXT_PUBLIC_IS_CELEBRATORY_WALLETS_ENABLED === 'true'

export const IS_SWILE_MAIS_INVOICES_ENABLED =
  process.env.NEXT_PUBLIC_IS_SWILE_MAIS_INVOICES_ENABLED === 'true'

export const FORCE_SBS_MODULES =
  process.env.NEXT_PUBLIC_FORCE_SBS_MODULES === 'true'

export const FORCE_RECARDING_MODULES =
  process.env.NEXT_PUBLIC_FORCE_RECARDING_MODULES === 'true'

export const IS_RECARDING_PREFERENCE_SURVEY_ENABLED =
  process.env.NEXT_PUBLIC_IS_RECARDING_PREFERENCE_SURVEY_ENABLED === 'true'

export const IS_QUALTRICS_ENABLED =
  process.env.NEXT_PUBLIC_IS_QUALTRICS_ENABLED === 'true'

// Kill switch to take QR Code Swile (PIX) payment temporarily out of the air.
// Defaults to enabled; set NEXT_PUBLIC_IS_QR_CODE_PAYMENT_DISABLED=true to disable.
export const IS_QR_CODE_PAYMENT_DISABLED =
  process.env.NEXT_PUBLIC_IS_QR_CODE_PAYMENT_DISABLED === 'true'
